import React from "react";
import slugify from 'slugify';

const deal_url = (deal) => {
  let baseUrl = '/marketplace/';

  if (deal.vendor && deal.name) {
    // let text = deal.vendor.name + " " + deal.name;
    // return baseUrl + text.toLowerCase()
    //   .replace(/[^\w ]+/g, '')
    //   .replace(/ +/g, '-') + `/${deal.id}`;
    baseUrl = `/marketplace/${slugify(deal.vendor.name, { lower: true })}/${slugify(deal.name, { lower: true })}/${deal.id}`;
  }

  return baseUrl;
};

export default function Hit({ hit }) {
  
  return (
    <article className="hit">
      {/* <div className="hit-image">
        <img src={hit.image} alt={hit.name} />
      </div> */}
      <div>
        {/* <h1>
          <Snippet hit={hit} attribute="name" />
        </h1> */}
        <a href={deal_url(hit)} className="aa-ItemLink hover:border-r-1 py-4">
          <div className="aa-ItemContent">
            <div className="aa-ItemTitle">
              <span className="text-body-1-md text-blue-700 font-primary">{`${hit.vendor.name}: ${hit.name}`}</span>
              {/* <Snippet hit={hit} attribute="name" /> */}
            </div>
          </div>
        </a>
        {/* <div>
          By <strong>{hit.brand}</strong> in{' '}
          <strong>{hit.categories[0]}</strong>
        </div> */}
      </div>
    </article>
  );
}
